import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { Accordion } from 'react-accessible-accordion';
import QuestionBlock from '../GoalsFlow/QuestionBlock';
// import DebugData from '../shared/DebugData';
import { getSchemaFromGoal } from '../../constants/utils';
import Button from '../shared/Button';
import Bullets from '../shared/Bullets';
import Text from '../shared/Text';
import Title from '../shared/Title';
import { palette } from '../../constants/styles';
import Icon from '../shared/Icon';
import FAQuestion from '../landing/FAQuestion';

const StyledTrialForm = styled.div`
  height: calc(100vh - 50px);
`;

const StyledForm = styled(Form)``;

const SubmitContainer = styled.div`
  display: none;

  ${({ show }) =>
    show &&
    css`
      display: block;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      opacity: 1;
      z-index: 2000000;
      margin-top: -4rem;
    `}
`;

const StyledErrorBlock = styled.div`
  opacity: 0;
  margin-top: -55px;
  display: none;

  ${({ show }) =>
    show &&
    css`
      display: block;
      opacity: 1;
    `}

  ${({ hide }) =>
    hide &&
    css`
      display: none;
      opacity: 0;
    `}
`;

const StyledValueProp = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: flex-start;
  margin-top: 1em;
  margin-bottom: -20px;
`;

const Bullet = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
`;

const TrialForm = ({
  questionnaire,
  onQuestionFocus,
  onQuestionChange,
  onQuestionBlur,
  onStepSubmit,
  goToNextInput,
  isFinished,
  valuePropContent,
  ...rest
}) => (
  <StyledTrialForm>
    {questionnaire.map((goal, index) => (
      <Formik
        validationSchema={Yup.object().shape({
          ...getSchemaFromGoal(goal),
        })}
        key={goal.value}
      >
        {(props) => (
          <StyledForm>
            <StyledValueProp>
              <Title level={4} color={palette.primaryColor}>
                {valuePropContent.title}
              </Title>
              <Text type="body1">{valuePropContent.subtitle}</Text>
              <Bullets bullets={valuePropContent.bullets} />
              {valuePropContent.question && (
                <Accordion
                  accordion={false}
                  style={{
                    width: '100%',
                    marginTop: '10px',
                    marginBottom: '20px',
                    maxWidth: '750px',
                  }}
                >
                  <FAQuestion
                    question={{
                      question: valuePropContent.question.title,
                      answer: valuePropContent.question.answer,
                      metric: 'Cafecin | CuentameMas | No me identifico',
                    }}
                    expanded={false}
                    borderBottom
                  />
                </Accordion>
              )}
            </StyledValueProp>
            <QuestionBlock
              goalIndex={index}
              goal={goal}
              form={props}
              isFocused={goal.isFocused}
              isAnswered={goal.isAnswered}
              onFocus={onQuestionFocus}
              onChange={onQuestionChange}
              onBlur={onQuestionBlur}
              totalQuestions={goal.questions.length}
              goToNextInput={goToNextInput}
              formIsValid={props.isValid}
              noMargin
              {...rest}
            />
            <StyledErrorBlock
              show={isFinished && !props.isValid}
              hide={!isFinished || props.isValid}
            >
              <Text type="errorMessage" medium>
                Oops! Encontramos errores en una o más de las preguntas anteriores...
              </Text>
            </StyledErrorBlock>
            {/* <DebugData data={props} /> */}
          </StyledForm>
        )}
      </Formik>
    ))}
  </StyledTrialForm>
);

TrialForm.propTypes = {
  isValid: PropTypes.bool,
  questionnaire: PropTypes.array,
  isFinished: PropTypes.bool,
  onQuestionFocus: PropTypes.func,
  onQuestionChange: PropTypes.func,
  onQuestionBlur: PropTypes.func,
  onStepSubmit: PropTypes.func,
  goToNextInput: PropTypes.func,
};

TrialForm.defaultProps = {
  isValid: true,
  questionnaire: [],
  isFinished: false,
  onQuestionFocus: () => {},
  onQuestionChange: () => {},
  onQuestionBlur: () => {},
  onStepSubmit: () => {},
  goToNextInput: () => {},
};

export default TrialForm;
